import React, { Component } from 'react'

const scope = 'Footer'
export default class Footer extends Component {
  render() {
    const { loggedIn } = this.props
    // console.log(this.props)
    return (
      <div className={scope}>
        <ul>
          <li>
            <a href='/'>Home</a>
          </li>
          <li>
            <a href='/faq'>Questions</a>
          </li>
          {loggedIn && (
            <li>
              <a href='/settings'>Settings</a>
            </li>
          )}
          {loggedIn && (
            <li>
              <a href='/logout'>Log Out</a>
            </li>
          )}
          {!loggedIn && (
            <li>
              <a href='/api/login'>Log In</a>
            </li>
          )}
        </ul>
        Copyright &copy;{' '}
        <span className='info' title='Hindsight is always...'>
          2020
        </span>{' '}
        <a
          target='_blank'
          rel='noopener noreferrer'
          href='https://www.twitch.tv/silencedraconem'
          title='Silence on Twitch'
        >
          Silence Draconem
        </a>
        <br />
        All Rights Reserved
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/footer/footer.jsx